import { LANGS, CHANNELS, nf } from "./logic";

// 시안 renderChat 의 분류별 막대·키워드 구름·거르기 줄

export function CategoryBars({ rows, cat, catLabel, onPick }) {
    const mx = Math.max(1, ...rows.map((r) => r.count));
    return (
        <div className="pn" style={{ borderBottom: "1px solid var(--line2)" }}>
            {rows.map((r) => {
                const on = r.quick_category_id != null && r.quick_category_id === cat;
                const clickable = r.quick_category_id != null;
                return (
                    <div key={r.quick_category_id ?? `none-${r.name}`} className="bar" style={clickable ? undefined : { cursor: "default" }}
                        onClick={clickable ? () => onPick(r.quick_category_id) : undefined}
                        role={clickable ? "button" : undefined} tabIndex={clickable ? 0 : undefined}
                        onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onPick(r.quick_category_id); } } : undefined}>
                        <span className="lab" style={on ? { color: "var(--pri)", fontWeight: 700 } : undefined}>{r.name || "분류 없음"}</span>
                        <span className="tr"><span className="fl" style={{ width: `${(r.count / mx) * 100}%` }}></span></span>
                        <span className="n">{nf(r.count)}건</span>
                    </div>
                );
            })}
            <div className="note">막대를 누르면 그 분류만 아래에 보입니다{cat != null && catLabel ? ` · 지금 「${catLabel}」만 표시 중` : ""}</div>
        </div>
    );
}

const PAL = ["#1e3a8a", "#2563eb", "#334155", "#1d4ed8", "#475569"];
export const KW_SHOW = 24;

export function KeywordPanel({ items, q, period, stats, onPick, error }) {
    const top = (items || []).slice(0, KW_SHOW);
    const mx = Math.max(1, ...top.map((t) => t.count));
    const mn = Math.min(mx, ...top.map((t) => t.count));
    // 시안처럼 크기 순으로만 늘어서지 않게 고르게 섞는다
    const shuffled = top.map((t, i) => [t, i]).sort((a, b) => ((a[1] * 7) % 5) - ((b[1] * 7) % 5));
    return (
        <div className="pn" style={{ borderBottom: "1px solid var(--line2)" }}>
            <div className="kwband">{period} · 대화 {nf(stats.total)}건에서 뽑은 키워드 · 크게 보일수록 자주 나온 단어 · 누르면 그 단어가 들어간 대화만 아래에 보입니다</div>
            <div className="wcloud">
                {items === null ? <span className="note">{error || "불러오는 중…"}</span>
                    : shuffled.length ? shuffled.map(([t, i]) => {
                        const r = mx === mn ? 1 : (t.count - mn) / (mx - mn);
                        return (
                            <button key={t.keyword} className={q === t.keyword ? "on" : ""} title={`${t.keyword} · ${t.count}회`} onClick={() => onPick(t.keyword)}
                                style={{ fontSize: Math.round(13 + r * 26), color: PAL[i % PAL.length], opacity: (0.6 + r * 0.4).toFixed(2) }}>{t.keyword}</button>
                        );
                    }) : <span className="note">키워드가 없습니다</span>}
            </div>
            <div className="kwstat">
                <div><b>{nf(stats.total)}</b><span>전체 대화</span></div>
                <div><b>{nf(stats.answered)}</b><span>응답 성공</span></div>
                <div><b>{nf(stats.failed)}</b><span>응답 실패</span></div>
                <div><b>{nf((items || []).length)}</b><span>고유 키워드</span></div>
            </div>
        </div>
    );
}

export function FilterBar({ f, qInput, open, showReset, onChange, onQ, onReset }) {
    return (
        <div className={`cbar chbar ${open ? "open" : ""}`}>
            <div className="fg"><label>기간</label>
                <input type="date" className="inp" aria-label="시작일" value={f.from} max={f.to || undefined} onChange={(e) => onChange({ from: e.target.value })} />
                <span style={{ color: "var(--tx3)" }}>~</span>
                <input type="date" className="inp" aria-label="종료일" value={f.to} min={f.from || undefined} onChange={(e) => onChange({ to: e.target.value })} /></div>
            <div className="fg"><label htmlFor="ch-lang">언어</label>
                <select id="ch-lang" className="sel" value={f.lang} onChange={(e) => onChange({ lang: e.target.value })}>
                    <option value="">전체</option>{LANGS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
            <div className="fg"><label htmlFor="ch-ch">채널</label>
                <select id="ch-ch" className="sel" value={f.ch} onChange={(e) => onChange({ ch: e.target.value })}>
                    <option value="">전체</option>{CHANNELS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
            <div className="fg grow"><input className="inp" placeholder="질문 · 답변 · 상호 검색 (매장별 엑셀은 상호로 거른 뒤)" value={qInput} onChange={(e) => onQ(e.target.value)} /></div>
            {showReset && <button className="btn btn-sm btn-ghost" onClick={onReset}><i className="fa-solid fa-rotate-left"></i>초기화</button>}
        </div>
    );
}
